import { Component } from '@angular/core';
import { ElementBase } from "../element-base";

@Component({
  selector: 'app-element-single-line',
  templateUrl: './element-single-line.component.html',
  styleUrl: './element-single-line.component.scss'
})
export class ElementSingleLineComponent extends ElementBase {

}
